import React, { useEffect } from "react";
import { useDispatch , useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { onAllTaxLoad } from "../../../store/Settings/actions";
import Loading from "../../../components/Loading";
import '../setting.css'

export const Vat = ({ setOpenCreateTax, setTaxId }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => { dispatch(onAllTaxLoad())}, []);

    const {loading, tax_list} = useSelector(({settings}) => ({
        loading: settings.loading,
        tax_list: settings.tax_list,
    }));

    const createTaxHandle = () => {setOpenCreateTax((prev) => !prev)};

    const getTaxWithId = (id) => {
        setTaxId(id)
        setOpenCreateTax((prev) => !prev);
    };

    return (
        <Loading loading={loading}>
            <div className="grid grid-cols-1">
                <div className="rounded-lg shadow-md bg-white pt-4 pr-5 pb-52 pl-5">
                    <div className="text-right">
                        <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-3 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                            onClick={createTaxHandle}
                        >
                            {t("Create Tax")}
                        </button>
                    </div>

                    <table className="min-w-full mt-3 tax_table">
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    className="py-3 text-left text-sm font-bold"
                                >
                                    {t("Name")}
                                </th>
                                <th
                                    scope="col"
                                    className="px-4 py-3 text-left text-sm font-bold"
                                >
                                    {t("Locations")}
                                </th>
                                <th
                                    scope="col"
                                    className="px-4 py-3 text-left text-sm font-bold"
                                >
                                    {t("Status")}
                                </th>
                                <th
                                    scope="col"
                                    className="px-4 py-3 text-left text-sm font-bold"
                                >
                                    {t("Percentage")}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {tax_list?.map((item) => (
                                <tr
                                    key={item.id}
                                    onClick={()=>getTaxWithId(item.id)}
                                    className="bg-gray-50 hover:bg-gray-100 rounded-md cursor-pointer mb-1 border-none"
                                >
                                    <td className="px-4 py-2 whitespace-nowrap rounded-l-lg w-2/5">
                                        <div className="flex items-center justify-start">
                                            <div className="text-sm font-medium">
                                                {item.name}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2 whitespace-nowrap w-1/3">
                                        <div className="flex items-center justify-start">
                                            <div className="text-sm font-medium w-56 flex">
                                                {item.is_all_restaurants
                                                ? " All Locations"
                                                : <div className="truncate">
                                                    {item.restaurants_list.map((rest, index) => {
                                                        return <span> {rest.name}{item.restaurants_list.length - 1 !== index && ','}</span>;
                                                    })}
                                                  </div>
                                                }
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2 whitespace-nowrap w-1/5">
                                        <div className="flex items-center justify-start">
                                            <div className="text-sm font-medium">
                                                {item.is_enable? t("Enabled") : t("Disabled")}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2 whitespace-nowrap rounded-r-lg">
                                        <div className="flex items-center justify-start">
                                            <div className="text-sm font-medium">
                                                {item.rate} %
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Loading>

    );
};
